import { MdOutlineChevronRight } from 'react-icons/md';
import { CovalentBalanceItem } from '@shared/types/frontend';
import { SelectionMode } from '@shared/types/frontend/trade';
import { useState } from 'react';
import { toLocaleShortString } from '@/lib/misc/utils';
import TokenImage from '@/components/shared/TokenImage';
import { getNetworkLogo, getTokenImageFromAssetItem } from '@/lib/misc/tokenImageHelper';
import classNames from '@/lib/misc/classNames';
interface Props {
  mode: SelectionMode;
  setSelectAsset?: (value: boolean) => void;
  assets: CovalentBalanceItem[];
}
const SwapAssetsSelection = ({
  mode,
  setSelectAsset,
  assets
}: Props) => {
  const [isPressed, setIsPressed] = useState(false);
  const isSingleAsset = assets.length === 1;
  const multipleAssetsLogos = () => {
    return <div className='flex' data-sentry-component="multipleAssetsLogos" data-sentry-source-file="SwapAssetsSelection.tsx">
        {assets?.slice(0, 2)?.map((asset, index) => <TokenImage key={index} mainImageSrc={getTokenImageFromAssetItem(asset)} badgeImageSrc={getNetworkLogo(asset.network)} size={32} badgeSize={16} className={index === 0 ? '' : '-translate-x-4'} />)}
      </div>;
  };
  const assetsNames = () => {
    if (isSingleAsset) {
      return assets[0]?.contract_ticker_symbol ?? assets[0]?.contract_name;
    }
    const firstTwoAssets = assets.slice(0, 2);
    const firstTwoAssetsNames = firstTwoAssets.map(asset => toLocaleShortString(asset.contract_ticker_symbol ?? asset.contract_name, 5)).join(' and ');
    if (assets.length > 2) {
      return `${firstTwoAssetsNames} +${assets.length - 2}`;
    }
    return firstTwoAssetsNames;
  };
  let tokenImage = '';
  if (assets[0]) {
    tokenImage = getTokenImageFromAssetItem(assets[0]);
  }
  return <div className={classNames('flex items-center rounded-xl w-full bg-genius-blue text-genius-cream text-xs p-3 transition-transform', isPressed ? 'scale-[0.96]' : 'scale-[1]')} onTouchStart={() => setIsPressed(true)} onTouchEnd={() => {
    setIsPressed(false);
    setSelectAsset(true);
  }} onTouchCancel={() => setIsPressed(false)} data-sentry-component="SwapAssetsSelection" data-sentry-source-file="SwapAssetsSelection.tsx">
      <div className='flex-1 flex items-center gap-2'>
        {isSingleAsset ? <TokenImage mainImageSrc={tokenImage} badgeImageSrc={getNetworkLogo(assets[0]?.network)} size={32} badgeSize={16} className='border border-genius-indigo' /> : multipleAssetsLogos()}
        <div className='flex flex-col gap-[2px]'>
          <div className='font-light text-left text-genius-cream/50'>{mode}</div>
          <div className='font-light text-left text-genius-cream'>
            {assets.length ? assetsNames() : 'Select'}
          </div>
        </div>
      </div>
      <MdOutlineChevronRight size={16} data-sentry-element="MdOutlineChevronRight" data-sentry-source-file="SwapAssetsSelection.tsx" />
    </div>;
};
export default SwapAssetsSelection;